<template>
  <OverlayLoader :visible="isLoadingCreate" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4 pb-1">
      <div class="row">
        <div class="col-lg-5 col-sm-6">
          <div class="form-group">
            <label class="label text-secondary">Nombre de la Opción</label>
            <input
              type="text"
              class="form-control h-45"
              placeholder="Ingresar el Nombre de la Opción"
              v-model="playName"
              @input="clearError('errors.playName')"
              :disabled="idPlay != ''"
            />
            <div v-if="errors.playName" class="input-error">
              {{ errors.playName }}
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-sm-6 mt-4">
          <button
            v-show="idPlay == ''"
            type="button"
            @click="createPlayName()"
            class="btn btn-primary py-1 px-3 me-3 mt-2 fw-medium fs-14 rounded-3 hover-bg"
          >
            <span class="py-sm-1 d-block">
              <span>Crear jugada</span>
            </span>
          </button>
          <button
            type="button"
            class="btn btn-primary py-1 px-3 mt-2 fw-medium fs-14 rounded-3 hover-bg"
            @click="PrevPage"
          >
            <span class="py-sm-1 d-block">
              <span>Regresar</span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body p-4" v-show="idPlay != ''">
      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <div class="form-group">
            <label class="label text-secondary">Acción</label>
            <select
              class="form-select form-control h-45"
              aria-label="Default select example"
              v-model="playTypeId"
              @change="resetValues()"
              :disabled="paramIsQuestion"
            >
              <option :value="0">-- Seleccionar --</option>
              <option :value="PLAY_TYPES.COMBINE">Contenido</option>
              <option :value="PLAY_TYPES.QUIZ">Quiz</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card bg-white border-0 rounded-3 mb-4"
    v-if="playTypeId == PLAY_TYPES.COMBINE"
  >
    <div class="card-body p-4">
      <form @submit.prevent="validateForm_Content">
        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">¿Subir contenido?</label>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  v-model="playType.flagUploadContent"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault"
                ></label>
              </div>
              <div class="input-error">{{ errors.flagUploadContent }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Descripción</label>
              <TextEditor
                class="text-editor"
                v-model="playType.description"
                :placeholder="'Ingrese el contenido'"
              />

              <div class="input-error">{{ errors.description }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group mb-4">
              <label class="label text-secondary strong"
                >Tipo de Multimedia</label
              >
              <select
                v-model="playType.multimediaTypeId"
                @change.prevent="
                  setMultimediaTypeContent(playType.multimediaTypeId)
                "
                class="form-select form-control h-45"
                aria-label="Default select example"
              >
                <option :value="null">{{ LABELS.SELECT }}</option>
                <option
                  v-for="option in multimediaOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
              <div class="input-error">{{ errors.multimediaTypeId }}</div>
            </div>
          </div>
          <div class="col-lg-12">
            <div
              class="form-group mb-2"
              v-show="
                playType.multimediaTypeId != null &&
                playType.multimediaTypeId != MULTIMEDIA_TYPES.LINK
              "
            >
              <label class="label text-secondary">Multimedia</label>
              <FilePond
                style="margin-bottom: -12px important!"
                ref="filePondRef"
                name="fileMultimedia"
                :maxFileSize="(playType.multimediaTypeId==MULTIMEDIA_TYPES.VIDEO)?'20MB':'2MB'"
                :accepted-file-types="supportedFormats"
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(
                  ', '
                )}`"
                credits=""
                @updatefiles="handleUpdateFiles"
                @removefile="handleRemoveFile"
                @input="clearError('fileMultimedia')"
                v-if="!playType.urlMultimedia"
              />
              <div class="input-error">{{ errors.fileMultimedia }}</div>
            </div>
          </div>
          <div v-show="playType.multimediaTypeId == MULTIMEDIA_TYPES.LINK">
            <div class="form-group mb-4">
              <label class="label text-secondary">Link</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingrese el link"
                v-model="playType.link"
                @input="clearError('link')"
              />
              <div class="input-error">{{ errors.link }}</div>
            </div>
            <div class="form-group mb-4">
              <label class="label text-secondary">Texto del Link</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingrese el texto del link"
                v-model="playType.steps"
                @input="clearError('steps')"
              />
              <div class="input-error">{{ errors.steps }}</div>
            </div>
          </div>
          <div>
            <div>
              <div
                v-if="
                  playType.urlMultimedia &&
                  playType.multimediaTypeId == MULTIMEDIA_TYPES.IMAGE
                "
              >
                <img
                  :src="playType.urlMultimedia"
                  alt="Multimedia"
                  class="img-fluid mb-2 d-block"
                  style="width: 25%"
                />
              </div>
              <video
                v-if="videoBlobUrl"
                :src="videoBlobUrl"
                controls
                width="250"
              ></video>
              <audio
                v-if="audioUrl"
                :src="audioUrl"
                controls
                style="margin-top: 1rem"
              ></audio>
              <iframe
                v-if="pdfUrl"
                :src="pdfUrl"
                width="100%"
                height="700px"
              ></iframe>
            </div>
            <button
              @click.prevent="removeMultimediaFile"
              class="btn btn-danger"
            >
              Eliminar multimedia
            </button>
          </div>
        </div>

        <div class="col-lg-12 mt-4">
          <div class="d-flex flex-wrap gap-3">
            <button
              type="button"
              class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
              @click="PrevPage"
            >
              Cancelar
            </button>
            <button
              class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
              type="submit"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">{{
                playType.id == 0 ? "Crear Acción" : "Actualizar Acción"
              }}</span>
              <span
                class="spinner-border spinner-border-sm me-2"
                aria-hidden="true"
                v-if="isLoading"
              ></span>
              <span role="status" v-if="isLoading">Procesando...</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div
    class="card bg-white border-0 rounded-3 mb-4"
    v-if="playTypeId == PLAY_TYPES.QUIZ"
  >
    <div class="card-body p-4">
      <form @submit.prevent="validateForm_Question">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Tipo de Pregunta</label>
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="question.questionTypeId"
                @change="clearError('questionTypeId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="item.id"
                  v-for="(item, i) of itemsQuestionTypes"
                  :key="i"
                >
                  {{ item.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.questionTypeId }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Enunciado de la Pregunta</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el enunciado de la pregunta"
                v-model="question.sentence"
                @input="clearError('sentence')"
              />
              <div class="input-error">{{ errors.sentence }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Descripción</label>
              <TextEditor
                @input="clearError('description')"
                class="text-editor"
                v-model="question.description"
                :placeholder="'Ingrese el contenido'"
              />

              <div class="input-error">{{ errors.description }}</div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="question.questionTypeId == QUESTION_TYPE.SEMIOPEN"
        >
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Respuesta</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar la respuesta correcta"
                v-model="question.answer"
                @input="clearError('answer')"
              />
              <div class="input-error">{{ errors.answer }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Pista</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar una pista"
                v-model="question.hint"
                @input="clearError('hint')"
              />
              <div class="input-error">{{ errors.hint }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Reintentos</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder=""
                v-model="question.retries"
                @input="
                  handleQuestionInput($event, 'retries');
                  clearError('retries');
                "
                maxlength="2"
              />
              <div class="input-error">{{ errors.retries }}</div>
            </div>
          </div>
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Puntos bonus</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder=""
                v-model="question.bonusPoints"
                @input="
                  handleQuestionInput($event, 'bonusPoints');
                  clearError('bonusPoints');
                "
                maxlength="3"
              />
              <div class="input-error">{{ errors.bonusPoints }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Timer(Segundos)</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder=""
                v-model="question.timer"
                maxlength="18"
              />
              <div class="input-error">{{ errors.timer }}</div>
            </div>
          </div>
          <div
            class="col-lg-2 col-sm-6"
            v-if="question.timer != null && question.timer > 0"
          >
            <div class="form-group mb-4">
              <label class="label text-secondary">Siguiente acción</label>
              <select
                v-model="question.quizContentId"
                @change="handleQuizContentChange"
                class="form-select form-control h-45"
                aria-label="Default select example"
              >
                <option :value="null">{{ LABELS.SELECT }}</option>
                <option
                  :value="item.id"
                  v-for="(item, i) of itemsConfigNext"
                  :key="i"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>          
        </div>
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group mb-4">
              <label class="label text-secondary strong"
                >Tipo de Multimedia</label
              >
              <select
                v-model="question.multimediaTypeId"
                @change.prevent="
                  setMultimediaTypeContent(question.multimediaTypeId)
                "
                class="form-select form-control h-45"
                aria-label="Default select example"
              >
                <option :value="null">{{ LABELS.SELECT }}</option>
                <option
                  v-for="option in multimediaOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
              <div class="input-error">{{ errors.multimediaTypeId }}</div>
            </div>
          </div>
          <div class="col-lg-12" v-if="question.multimediaTypeId != null">
            <div class="form-group mb-4">
              <label class="label text-secondary">Multimedia</label>
              <FilePond
                v-show="question.multimediaTypeId != MULTIMEDIA_TYPES.LINK"
                ref="filePondRefQuestion"
                style="margin-bottom: -12px important!"
                name="fileMultimedia"
                :maxFileSize="(question.multimediaTypeId==MULTIMEDIA_TYPES.VIDEO)?'20MB':'2MB'"
                :accepted-file-types="supportedFormats"
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(
                  ', '
                )}`"
                credits=""
                @updatefiles="handleUpdateFiles"
                @removefile="handleRemoveFile"
                @input="clearError('fileMultimedia')"
                v-if="!question.urlMultimedia"
              />
              <div class="input-error">{{ errors.fileMultimedia }}</div>
            </div>
            <div v-show="question.multimediaTypeId == MULTIMEDIA_TYPES.LINK">
              <div class="form-group mb-4">
                <label class="label text-secondary">Link</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingrese el link"
                  v-model="question.link"
                  @input="clearError('link')"
                />
                <div class="input-error">{{ errors.link }}</div>
              </div>
              <div class="form-group mb-4">
                <label class="label text-secondary">Texto del Link</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingrese el texto del link"
                  v-model="question.steps"
                  @input="clearError('steps')"
                />
                <div class="input-error">{{ errors.steps }}</div>
              </div>
            </div>
            <div>
              <div
                v-if="
                  question.urlMultimedia &&
                  question.multimediaTypeId == MULTIMEDIA_TYPES.IMAGE
                "
              >
                <img
                  :src="question.urlMultimedia"
                  alt="Multimedia"
                  class="img-fluid mb-2 d-block"
                />
              </div>
              <video
                v-if="videoBlobUrlQuestion"
                :src="videoBlobUrlQuestion"
                controls
                width="270"
              ></video>
              <audio
                v-if="audioUrlQuestion"
                :src="audioUrlQuestion"
                controls
                style="margin-top: 1rem"
              ></audio>
              <iframe
                v-if="pdfUrlQuestion"
                :src="pdfUrlQuestion"
                width="100%"
                height="700px"
              ></iframe>
            </div>
            <button
              @click.prevent="removeMultimediaFile"
              class="btn btn-danger"
            >
              Eliminar multimedia
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div
              class="form-group mb-4"
              v-if="question.questionTypeId == QUESTION_TYPE.CLOSED"
            >
              <label class="label text-secondary">Tipo de Respuesta</label>
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="question.answerType"
                @change="clearError('answerType')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="item.id"
                  v-for="(item, i) of itemsAnswerTypes"
                  :key="i"
                >
                  {{ item.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.answerType }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8">
            <div
              class="card bg-white border-0 rounded-3 mb-4 mt-4"
              v-if="question.questionTypeId == QUESTION_TYPE.CLOSED"
            >
              <h4 class="fs-18 mb-4">Respuestas</h4>
              <div class="row">
                <div class="col-lg-10 col-sm-6">
                  <div class="form-group mb-4">
                    <div class="input-group h-45">
                      <input
                        maxlength="5000"
                        ref="questionInput"
                        type="text"
                        class="form-control"
                        placeholder="Ingresar la respuesta"
                        v-model="questionOptionText"
                        @keydown.enter.prevent="addQuestionOption"
                      />
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="addQuestionOption"
                      >
                        Agregar
                      </button>
                    </div>
                    <div class="input-error">
                      {{ errors.questionOptionText }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-error">{{ errors.questionOptions }}</div>
              <ul
                class="ps-0 mb-0 list-unstyled o-sortable cursor-move list-group"
                @dragover.prevent
                @drop="drop"
              >
                <li
                  v-for="(drag, index) in questionOptions"
                  :key="drag.id"
                  @dragstart="dragStart(index)"
                  @dragend="dragEnd()"
                  @dragover.prevent
                  @drop="dragDrop(index)"
                  draggable="true"
                  :class="[
                    'p-2 ps-3 rounded-2  d-flex align-items-center justify-content-between list-group-item list-group-item-primary bg-transparent text-primary',
                  ]"
                >
                  <!-- LEFT SIDE -->
                  <div class="d-flex align-items-center flex-grow-1">
                    <div
                      class="me-2 d-flex align-items-center justify-content-center"
                      style="width: 20px"
                    >
                      <i
                        class="material-symbols-outlined fs-16 text-primary cursor-move"
                        >drag_indicator</i
                      >
                    </div>
                    <div class="d-flex align-items-center form-check m-0">
                    <input
                      type="checkbox"
                      v-model="drag.isCorrect"
                      class="form-check-input me-3 mt-0"
                    />

                    <!-- Inline edit -->
                    <div
                      v-if="drag.isEditing"
                      class="d-flex align-items-center"
                    >
                      <input
                        type="text"
                        v-model="drag.option"
                        class="form-control form-control-sm h-45 me-2"
                        style="width: 710px; height: 36px"
                      />
                      <button
                        class="btn btn-sm btn-success text-success bg-transparent me-1 pb-0"
                        @click="saveOption(index)"
                        title="Guardar"
                      >
                        <span class="material-symbols-outlined fw-bold"
                          >check</span
                        >
                      </button>
                      <button
                        class="btn btn-sm btn-danger text-danger bg-transparent pb-0"
                        @click="cancelEdit(index)"
                        title="Cancelar"
                      >
                        <span class="material-symbols-outlined fw-bold"
                          >close</span
                        >
                      </button>
                    </div>

                    <!-- Normal view -->
                    <span v-else :class="['fs-13 fw-semibold']">
                      {{ drag.option }}
                    </span>
                  </div>
                </div>

                  <!-- RIGHT SIDE: Buttons -->
                  <div class="d-flex align-items-center" v-if="!drag.isEditing">
                    <button
                      type="button"
                      class="btn btn-sm btn-default"
                      :class="{
                        'text-success': drag.multimediaTypeId != null,
                        'text-primary': drag.multimediaTypeId == null,
                      }"
                      @click="editFile(index)"
                      title="Agregar multimedia"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >music_note_add</span
                      >
                    </button>
                    <button
                      v-if="
                        drag.id == 0 ||
                        question?.answerType == ANSWER_TYPES.SELECCION_MULTIPLE
                      "
                      type="button"
                      class="btn btn-sm btn-default text-primary"
                      :title="
                        question?.answerType == 2
                          ? 'No disponible para respuesta múltiple'
                          : 'Guardar los cambios para poder agregar la acción'
                      "
                      style="cursor: not-allowed"
                      @click.prevent
                    >
                      <span class="material-symbols-outlined menu-icon me-0">
                        asterisk
                      </span>
                    </button>

                    <button
                      v-else
                      type="button"
                      :class="
                        drag.isQuestion != null
                          ? 'btn btn-sm btn-default text-success'
                          : 'btn btn-sm btn-default text-primary'
                      "
                      @click="editFileQuestion(drag)"
                      :title="
                        drag.isQuestion != null
                          ? 'Actualizar acción'
                          : 'Agregar acción'
                      "
                    >
                      <span class="material-symbols-outlined menu-icon me-0">
                        asterisk
                      </span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-default text-primary"
                      @click="editOption(index)"
                      title="Editar"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >edit</span
                      >
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn-default text-primary"
                      @click="removeQuestionOption(index)"
                      title="Eliminar"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >delete</span
                      >
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-4">
            <div class="d-flex flex-wrap gap-3">
              <button
                type="button"
                class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                @click="PrevPage"
              >
                Cancelar
              </button>
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading">{{
                  question.id == 0 ? "Crear Acción" : "Actualizar Acción"
                }}</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlFileUpload"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlFileUploadLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlFileUploadLabel">
            Jugada - Archivo
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-8">
              <div class="form-group mb-4" v-if="questionOptionEdit">
                <label class="label text-secondary strong"
                  >Tipo de Multimedia</label
                >
                <select
                  v-model="questionOptionEdit.multimediaTypeId"
                  @change.prevent="
                    setMultimediaTypeQuestionOptionContent(
                      questionOptionEdit.multimediaTypeId
                    )
                  "
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT }}</option>
                  <option :value="MULTIMEDIA_TYPES.IMAGE">
                    {{ multimediaOptions[MULTIMEDIA_TYPES.IMAGE - 1].label }}
                  </option>
                  <option :value="MULTIMEDIA_TYPES.AUDIO">
                    {{ multimediaOptions[MULTIMEDIA_TYPES.AUDIO - 1].label }}
                  </option>
                </select>
                <div class="input-error">{{ errors.multimediaTypeId }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <FilePond
              ref="filePondRefAction"
              name="multimedia"
              :maxFileSize="'2MB'"
              :accepted-file-types="supportedFormatsModal"
              allow-multiple="false"
              :max-files="1"
              label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
              :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
              :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
              :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
              :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormatsModal.join(
                ', '
              )}`"
              credits=""
              @removefile="handleRemoveFileModal"
              v-if="!questionOptionEdit?.urlMultimediaBlob"
            />
            <div v-if="questionOptionEdit">
              <div
                v-if="
                  questionOptionEdit.multimediaTypeId ==
                    MULTIMEDIA_TYPES.IMAGE &&
                  questionOptionEdit?.urlMultimediaBlob
                "
              >
                <img
                  :src="questionOptionEdit?.urlMultimediaBlob"
                  alt="Multimedia"
                  class="img-fluid mb-2 d-block"
                  style="width: 50%"
                />
              </div>
              <audio
                v-if="
                  questionOptionEdit.multimediaTypeId ==
                    MULTIMEDIA_TYPES.AUDIO &&
                  questionOptionEdit?.urlMultimediaBlob
                "
                :src="questionOptionEdit?.urlMultimediaBlob"
                controls
                style="margin-top: 1rem"
              ></audio>
            </div>
            <div class="col-lg-5">
              <button
                @click.prevent="removeMultimediaFileModal"
                v-if="questionOptionEdit?.urlMultimediaBlob"
                class="btn btn-danger"
              >
                Eliminar multimedia
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeModalFile"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlFileUploadQuestion"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlFileUploadLabelQuestion"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h1
            class="modal-title fs-5"
            id="mdlFileUploadLabelQuestion"
            v-if="questionOptionFreeEdit"
          >
            Respuesta - {{ questionOptionFreeEdit.option }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-8">
              <div class="form-group mb-4" v-if="questionOptionFreeEdit">
                <label class="label text-secondary strong">Pregunta</label>
                <select
                  v-model="questionOptionFreeEdit.nextQuestionId"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="0">{{ LABELS.SELECT }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsQuestion"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div class="input-error">{{ errors.nextQuestionId }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeModalFileQuestion"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  playTypeRead_Schema,
  playTypeQuestion_Schema,
  questionOption_Schema,
  playName_Schema,
} from "@/schemas/playOptionSchema";
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";

import "@vuepic/vue-datepicker/dist/main.css";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
//import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
//import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";

import type { FilePond as FilePondInstance } from "filepond";

import { es } from "date-fns/locale";
import {
  LABELS,
  MULTIMEDIA_TYPES,
  PLAY_TYPES,
  QUESTION_TYPE,
  ANSWER_TYPES,
} from "@/utils/constants";
import TextEditor from "@/components/Common/TextEditor.vue";
import { allowOnlyNumbers } from "@/utils";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import { AnyMessageParams, number } from "yup";
// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
  FilePondPluginFilePoster
);
interface QuestionOption {
  id: number;
  option: string | null;
  isCorrect: boolean;
  isEditing: boolean;
  multimedia: null;
  multimediaTypeId: null;
  urlMultimedia: string | null;
  urlMultimediaBlob: any | null;
  nextQuestionId: number;
  playContentId: number;
  isQuestion: boolean | null;
}

export default defineComponent({
  name: "CreateRepository",
  components: { FilePond, TextEditor, OverlayLoader },

  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);
    const isLoadingCreate = ref(false);

    const playTypeId = ref(0);
    const pIdPlayType = ref(0);
    const paramIsQuestion = ref(false);
    const itemsTournament = ref<any[]>([]);
    const itemsQuestionTypes = ref<any[]>([]);
    const itemsAnswerTypes = ref<any[]>([]);
    const itemsQuestion = ref<any[]>([]);
    const itemsConfigNext = ref<any[]>([]);

    const initialPlayType = {
      id: 0,
      description: "",
      multimediaTypeId: null,
      fileMultimedia: null,
      urlMultimedia: null,
      link: null,
      playId: null,
      flagUploadContent: false,
      steps: null,
      optionMainId: 0,
    };
    const playType = ref({ ...initialPlayType });

    const initialQuestion = {
      id: 0,
      questionTypeId: null,
      sentence: null,
      hint: null,
      retries: 0,
      bonusPoints: null,
      multimediaTypeId: null,
      fileMultimedia: null,
      urlMultimedia: null,
      link: null,
      playId: null,
      description: "",
      answer: null,
      timer: null,
      quizContentId: null,
      isQuiz: false,
      optionMainId: 0,
      answerType: null,
    };

    const initialPlayConfigPage = {
      playId: 0,
      PlayQuizId: 0,
      questionPlayContentId: 0,
      questionId: 0,
      isQuestion: false,
      optionId: 0,
      playQuizOriginalId: 0
    };

    const question = ref<Record<string, any>>({ ...initialQuestion });
    const playConfigPage = ref<Record<string, any>>({
      ...initialPlayConfigPage,
    });

    const errors = ref<Record<string, string>>({});
    const questionInput = ref<HTMLInputElement | null>(null);
    const filePondRef = ref<FilePondInstance | null>(null);
    const filePondRefQuestion = ref<FilePondInstance | null>(null);
    const filePondRefAction = ref<FilePondInstance | null>(null);

    const supportedFormatsImage = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "image/gif",
    ];
    const supportedFormatsVideo = ["video/mp4"];
    const supportedFormatsFile = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "application/pdf",
    ];
    const supportedFormatsAudio = [
      "audio/mp3",
      "audio/mpeg",
      "audio/ogg",
      "audio/vnd.wav",
      "audio/mp4",
    ];
    const supportedFormats = ref([...supportedFormatsImage]);
    const supportedFormatsModal = ref([...supportedFormatsAudio]);
    const videoBlobUrl = ref<string | null>(null);
    const videoBlobUrlQuestion = ref<string | null>(null);
    const audioUrl = ref<string | null>(null);
    const audioUrlQuestion = ref<string | null>(null);
    const audioUrlAction = ref<string | null>(null);
    const pdfUrl = ref<string | null>(null);
    const pdfUrlQuestion = ref<string | null>(null);
    const questionOptionText = ref<string | null>(null);
    const questionOptions = ref<QuestionOption[]>([]);
    const questionOptionEdit = ref<QuestionOption>();
    const questionOptionFreeEdit = ref<QuestionOption>();

    const playName = ref<string | null>(null);
    const idPlay = ref<any>(null);
    const modalFileUpload = ref<any>(null);
    const modalFileUploadQuestion = ref<any>(null);

    onMounted(async () => {
      await initPage();
    });
    watch(
      () => route.params,
      () => {
        resetValues();
        initPage();
      }
    );

    async function initPage() {
      debugger;
      isLoadingCreate.value = true;
      try {
        const pQuery = route.query.data;
        const pData = Array.isArray(pQuery) ? pQuery[0] : pQuery;
        let nav = null;
        if (pData) {
          const decoded = JSON.parse(atob(pData));
          nav = decoded.nav;
          idPlay.value = decoded.playId;
        }

        await getPlayConfigPageById(Number(route.params.opid), nav);

        if (idPlay.value > 0) {
          if (playConfigPage.value.questionPlayContentId > 0) {
            paramIsQuestion.value = true;
            pIdPlayType.value = playConfigPage.value.questionPlayContentId;
            if (playConfigPage.value.isQuestion == true) {
              playTypeId.value = PLAY_TYPES.QUIZ;
            } else {
              playTypeId.value = PLAY_TYPES.COMBINE;
            }
          } else {
            paramIsQuestion.value = false;
            pIdPlayType.value = 0;
            playTypeId.value = 0;
          }

          if (idPlay.value != "" && idPlay.value != null) {
            await getPlayNameById(idPlay.value);
          }

          await getQuestionTypes();
          await getAnswerTypes();
          await getListQuestions();

          if (pIdPlayType.value != null && pIdPlayType.value > 0) {
            await getNextContentById(playTypeId.value, playConfigPage.value.playQuizOriginalId);
            await getPlayTypeById(pIdPlayType.value);
            await getPlayNameById(idPlay.value);
          }
          if (route.params.opid != "" && route.params.opid != null) {
            await getQuestionOptionNameById(route.params.opid);
          }
        }
        const modalFileUploadElem = document.getElementById("mdlFileUpload");
        if (modalFileUploadElem && window.bootstrap) {
          modalFileUpload.value = new window.bootstrap.Modal(
            modalFileUploadElem
          );
          modalFileUpload.value.hide();
        }

        const modalFileUploadElemQuestion = document.getElementById(
          "mdlFileUploadQuestion"
        );
        if (modalFileUploadElemQuestion && window.bootstrap) {
          modalFileUploadQuestion.value = new window.bootstrap.Modal(
            modalFileUploadElemQuestion
          );
          modalFileUploadQuestion.value.hide();
        }
        isLoadingCreate.value = false;
      } catch (ex) {
        isLoadingCreate.value = false;
        toast.error(`Error a ver el detalle`, {
          timeout: 2000,
        });
        router.push({
          name: "PlaysPage",
        });
      }
    }
    const PrevPage = async () => {
      await getPlayConfigPageById(Number(route.params.opid), "0");
      if (playConfigPage.value.playQuizId > 0) {
        router
          .push(`/play-type/question/edit/${playConfigPage.value.playQuizId}`)
          .catch((err) => {
            console.error("Navigation error:", err);
          });
      } else {
        const payload = {
          nav: "1", //siguiente nivel del árbol
          playId: idPlay.value,
        };
        const encoded = btoa(JSON.stringify(payload));
        router.push({
          name: "PlaysOptionEdit",
          params: {
            id: playConfigPage.value.questionId,
            "play-type": PLAY_TYPES.QUIZ,
            opid: playConfigPage.value.optionId,
          },
          query: {
            data: encoded,
          },
        });
      }
    };
    const getListQuestions = async () => {
      try {
        const response = await api.get(`/question/questions`);
        itemsQuestion.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getPlayNameById = async (id: any) => {
      try {
        const response = await api.get(`/play/${id}/name`);
        playName.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getQuestionOptionNameById = async (id: any) => {
      try {
        const response = await api.get(`/question/${id}/name-question-0ption`);
        playName.value = playName.value + " | " + response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

  const getNextContentById = async (type: number, id: any) => {
      try {
        const response = await api.get(
          `/play/config-next-order?playTypeId=${type}&id=${id}`
        );
        itemsConfigNext.value = response.data.map((item: any) => ({
          ...item,
          name: truncateText(
            item.type == true ? "Quiz: " : "Contenido: ",
            stripHtml(item.name),
            50
          ),
        }));
      } catch (ex) {
        console.error(ex);
      }
    };
    const stripHtml = (html: string) => {
      if (!html) return "";
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    };
    const truncateText = (type: string, text: string, length = 50) => {
      if (!text) return "";
      return text.length > length
        ? type + text.substring(0, length) + "..."
        : type + text;
    };
    const handleQuizContentChange = () => {
      try {
        if (!question.value.quizContentId) {
          question.value.isQuiz = false;
          return;
        }
        const selectedItem = itemsConfigNext.value.find(
          (x) => x.id === question.value.quizContentId
        );
        question.value.isQuiz = selectedItem ? selectedItem.type : false;
      } catch (ex) {
        console.error(ex);
      }
    };
    const handleUpdateFiles = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          playType.value.fileMultimedia = fileItems.length
            ? fileItems[0].file
            : null;

          const file = fileItems[0]?.file;
          if (file && file.type.startsWith("video/")) {
            videoBlobUrl.value = URL.createObjectURL(file);
          } else if (file && file.type.startsWith("audio/")) {
            audioUrl.value = URL.createObjectURL(file);
          } else if (file && file.type === "application/pdf") {
            pdfUrl.value = URL.createObjectURL(file);
          } else {
            videoBlobUrl.value = null;
            audioUrl.value = null;
            pdfUrl.value = null;
          }
        } else {
          question.value.fileMultimedia = fileItems.length
            ? fileItems[0].file
            : null;

          const file = fileItems[0]?.file;
          if (file && file.type.startsWith("video/")) {
            videoBlobUrlQuestion.value = URL.createObjectURL(file);
          } else if (file && file.type.startsWith("audio/")) {
            audioUrlQuestion.value = URL.createObjectURL(file);
          } else if (file && file.type === "application/pdf") {
            pdfUrlQuestion.value = URL.createObjectURL(file);
          } else {
            videoBlobUrlQuestion.value = null;
            audioUrlQuestion.value = null;
            pdfUrlQuestion.value = null;
          }
        }
      }
    };

    const handleRemoveFile = () => {
      if (playTypeId.value == PLAY_TYPES.COMBINE) {
        playType.value.urlMultimedia = null;
        playType.value.fileMultimedia = null;
        if (
          playType.value.multimediaTypeId == (MULTIMEDIA_TYPES.VIDEO as number)
        ) {
          videoBlobUrl.value = null;
        } else if (
          playType.value.multimediaTypeId == (MULTIMEDIA_TYPES.AUDIO as number)
        ) {
          audioUrl.value = null;
        } else if (
          playType.value.multimediaTypeId == (MULTIMEDIA_TYPES.FILE as number)
        ) {
          pdfUrl.value = null;
        }
      } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
        question.value.urlMultimedia = null;
        question.value.fileMultimedia = null;
        if (question.value.multimediaTypeId == MULTIMEDIA_TYPES.VIDEO) {
          videoBlobUrlQuestion.value = null;
        } else if (
          question.value.multimediaTypeId == (MULTIMEDIA_TYPES.AUDIO as number)
        ) {
          audioUrlQuestion.value = null;
        } else if (
          question.value.multimediaTypeId == (MULTIMEDIA_TYPES.FILE as number)
        ) {
          pdfUrlQuestion.value = null;
        }
      }
    };

    const validateForm_Content = async () => {
      try {
        errors.value = {};
        await playTypeRead_Schema(supportedFormats.value).validate(
          playType.value,
          { abortEarly: false }
        );
        isLoading.value = true;

        await createPlayType();
        isLoading.value = false;
      } catch (err: any) {
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const getPlayConfigPageById = async (opid: number, nav: any) => {
      playConfigPage.value = { ...initialPlayConfigPage };
      try {
        const response = await api.get(
          `/play-type-page?optionId=${opid}&isNextPage=${nav}`
        );
        const responseFormat = response.data;
        if (responseFormat != null) {
          playConfigPage.value = responseFormat;
        }
      } catch (ex) {
        console.error(ex);
      }
    };
    const getPlayTypeById = async (id: any) => {
      debugger;
      try {
        const response = await api.get(
          playTypeId.value == PLAY_TYPES.QUIZ
            ? `/question/${id}`
            : `/play-type?playTypeId=${playTypeId.value}&id=${id}`
        );
        const responseFormat = response.data;

        if (responseFormat.urlMultimedia) {
          responseFormat.urlMultimedia =
            process.env.VUE_APP_API_URL + "/" + responseFormat.urlMultimedia;
        }

        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          playType.value = responseFormat;

          if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.VIDEO) {
            videoBlobUrl.value = responseFormat.urlMultimedia;
          } else if (
            responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            audioUrl.value = responseFormat.urlMultimedia;
          } else if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.FILE) {
            pdfUrl.value = responseFormat.urlMultimedia;
          }
        } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
          question.value = responseFormat;
          questionOptions.value = responseFormat.options;
          question.value.options = null;

          if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.VIDEO) {
            videoBlobUrlQuestion.value = responseFormat.urlMultimedia;
          } else if (
            responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            audioUrlQuestion.value = responseFormat.urlMultimedia;
          } else if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.FILE) {
            pdfUrlQuestion.value = responseFormat.urlMultimedia;
          }

          questionOptions.value.forEach((element) => {
            if (element.urlMultimedia != null) {
              element.urlMultimedia =
                process.env.VUE_APP_API_URL + "/" + element.urlMultimedia;
              element.urlMultimediaBlob = element.urlMultimedia;
            }
          });
        }
      } catch (ex) {
        console.error(ex);
      }
    };

    const createPlayType = async () => {
      try {
        let response: any;
        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          playType.value.optionMainId = Number(route.params.opid);
          const formData = buildFormData(playType.value);

          response = await api.postForm(`/play-type/content-action`, formData);
        } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
          if (!question.value.timer) {
            question.value.isQuiz = false;
            question.value.quizContentId = null;
          }
        if (question.value.questionTypeId != QUESTION_TYPE.CLOSED) {
            question.value.answerType = null;
          }
          question.value.optionMainId = Number(route.params.opid);
          const formDataQuestion = buildFormData(question.value);

          if (
            questionOptions.value != null &&
            questionOptions.value.length > 0
          ) {
            formDataQuestion.append(
              "options",
              JSON.stringify(
                questionOptions.value.map((o, i) => ({
                  id: o.id,
                  option: o.option,
                  isCorrect: o.isCorrect,
                  isEditing: o.isEditing,
                  multimediaTypeId: o.multimediaTypeId,
                  multimediaKey: o.multimedia ? `option_multimedia_${i}` : null, // track which file belongs to which
                  nextQuestionId: o.nextQuestionId,
                  playContentId: o.playContentId,
                  isQuestion: o.isQuestion,
                  order: i + 1
                }))
              )
            );

            // Append each file separately
            questionOptions.value.forEach((o, i) => {
              if (o.multimedia) {
                formDataQuestion.append(`option_multimedia_${i}`, o.multimedia);
              }
            });
          }

          if (question.value.questionTypeId == QUESTION_TYPE.SEMIOPEN) {
            formDataQuestion.append(
              "options",
              JSON.stringify([
                {
                  id: 0,
                  option: question.value.answer,
                  isCorrect: true,
                  isEditing: false,
                  multimediaTypeId: null,
                },
              ])
            );
          }

          response = await api.postForm(`/question`, formDataQuestion);
        }
        if (response.data.return) {
          let flagNew = false;
          if (playTypeId.value == PLAY_TYPES.QUIZ) {
            flagNew = question.value.id == 0;
          } else {
            flagNew = playType.value.id == 0;
          }
          toast.success(
            `La Acción fue ${
              flagNew == true ? "creada" : "actualizada"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );

          const result = await Swal.fire({
            html: `La Acción fue ${
              flagNew == true ? "creada" : "actualizada"
            } con éxito.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: `Regresar a la lista`,
            cancelButtonText: "Continuar editando",
          });
          isLoadingCreate.value = true;
          if (result.isConfirmed) {
            await PrevPage();
          } else {
            await resetValues();
            await initPage();
          }
          isLoadingCreate.value = false;
        }
      } catch (ex) {
        toast.error("La acción no pudo ser creada.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoadingCreate.value = false;
      }
    };

    const removeMultimediaFile = async () => {
      if (playTypeId.value == PLAY_TYPES.COMBINE) {
        playType.value.urlMultimedia = null;
      } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
        question.value.urlMultimedia = null;
      }

      clearVideoBlob();
      clearAudio();
      clearFile();
    };

    const multimediaOptions = computed(() =>
      Object.entries(MULTIMEDIA_TYPES).map(([key, value]) => ({
        label: key,
        value: value,
      }))
    );

    const setMultimediaTypeContent = (idMultimediaType: number | null) => {
      if (idMultimediaType) {
        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          playType.value.urlMultimedia = null;
          playType.value.fileMultimedia = null;
          if (filePondRef.value) {
            filePondRef.value?.removeFiles();
          }
        } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
          question.value.urlMultimedia = null;
          question.value.fileMultimedia = null;
          if (filePondRefQuestion.value) {
            filePondRefQuestion.value?.removeFiles();
          }
        }
        switch (idMultimediaType) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormats.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.VIDEO:
            supportedFormats.value = [...supportedFormatsVideo];
            break;
          case MULTIMEDIA_TYPES.FILE:
            supportedFormats.value = [...supportedFormatsFile];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormats.value = [...supportedFormatsAudio];
            break;
        }

        clearVideoBlob();
        clearAudio();
        clearFile();
      } else {
        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          playType.value.urlMultimedia = null;
          playType.value.fileMultimedia = null;
          playType.value.multimediaTypeId = null;
          if (filePondRef.value) {
            filePondRef.value?.removeFiles();
          }
          clearVideoBlob();
          clearAudio();
          clearFile();
        } else {
          question.value.fileMultimedia = null;
          question.value.urlMultimedia = null;
          if (filePondRefQuestion.value) {
            filePondRefQuestion.value?.removeFiles();
          }
          clearVideoBlob();
          clearAudio();
          clearFile();
        }
      }
    };

    const clearVideoBlob = () => {
      if (playTypeId.value == PLAY_TYPES.COMBINE) {
        if (videoBlobUrl.value) {
          URL.revokeObjectURL(videoBlobUrl.value);
          videoBlobUrl.value = null;
        }
      } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
        if (videoBlobUrlQuestion.value) {
          URL.revokeObjectURL(videoBlobUrlQuestion.value);
          videoBlobUrlQuestion.value = null;
        }
      }
    };

    const clearAudio = () => {
      if (playTypeId.value == PLAY_TYPES.COMBINE) {
        if (audioUrl.value) {
          URL.revokeObjectURL(audioUrl.value);
          audioUrl.value = null;
        }
      } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
        if (audioUrlQuestion.value) {
          URL.revokeObjectURL(audioUrlQuestion.value);
          audioUrlQuestion.value = null;
        }
      }
    };

    const clearFile = () => {
      if (playTypeId.value == PLAY_TYPES.COMBINE) {
        if (pdfUrl.value) {
          URL.revokeObjectURL(pdfUrl.value);
          pdfUrl.value = null;
        }
      } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
        if (pdfUrlQuestion.value) {
          URL.revokeObjectURL(pdfUrlQuestion.value);
          pdfUrlQuestion.value = null;
        }
      }
    };

    const validateForm_Question = async () => {
      try {
        errors.value = {};

        if (!question.value.multimediaTypeId) {
          if (filePondRefQuestion.value) {
            filePondRefQuestion.value?.removeFiles();
            question.value.fileMultimedia = null;
          }
        }
        await playTypeQuestion_Schema(supportedFormats.value).validate(
          { ...question.value, questionOptions: questionOptions.value },
          { abortEarly: false }
        );
        isLoading.value = true;

        await createPlayType();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const getQuestionTypes = async () => {
      try {
        const response = await api.get(`/common/question-types`);
        itemsQuestionTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getAnswerTypes = async () => {
      try {
        const response = await api.get(`/common/answer-type`);
        itemsAnswerTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    function handleQuestionInput(event: Event, field: string) {
      const target = event.target as HTMLInputElement;
      question.value[field] = allowOnlyNumbers(target.value);
    }

    const dragIndex = ref<number | null>(null);

    const dragStart = (index: number) => {
      dragIndex.value = index;
    };

    const dragEnd = () => {
      dragIndex.value = null;
    };

    const dragDrop = (targetIndex: number) => {
      if (dragIndex.value !== null && targetIndex !== dragIndex.value) {
        const [movedItem] = questionOptions.value.splice(dragIndex.value, 1);
        questionOptions.value.splice(targetIndex, 0, movedItem);
        dragIndex.value = null;
      }
    };

    const drop = (event: DragEvent) => {
      event.preventDefault();
    };

    const addQuestionOption = async () => {
      try {
        errors.value = {};

        await questionOption_Schema.validate(
          { questionOptionText: questionOptionText.value },
          { abortEarly: false }
        );
        if (questionOptions.value == null) {
          questionOptions.value = [];
        }
        questionOptions.value.push({
          id: 0,
          option: questionOptionText.value,
          isCorrect: false,
          isEditing: false,
          multimedia: null,
          multimediaTypeId: null,
          urlMultimedia: null,
          urlMultimediaBlob: null,
          nextQuestionId: 0,
          playContentId: 0,
          isQuestion: null,
        });

        questionOptionText.value = null;
        questionInput.value?.focus();
      } catch (err: any) {
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
      }
    };

    const editQuestionOption = async (index: number) => {
      questionOptions.value.splice(index, 1);
    };

    const editOption = async (index: number) => {
      questionOptions.value[index].isEditing = true;
    };
    const cancelEdit = async (index: number) => {
      questionOptions.value[index].isEditing = false;
    };
    const saveOption = async (index: number) => {
      // You can validate or call backend here if needed
      questionOptions.value[index].isEditing = false;
    };

    const editFile = async (index: number) => {
      questionOptionEdit.value = questionOptions.value[index];
      if (questionOptionEdit.value.multimediaTypeId) {
        switch (questionOptionEdit.value.multimediaTypeId) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormatsModal.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormatsModal.value = [...supportedFormatsAudio];
            if (filePondRefAction.value) {
              filePondRefAction.value?.removeFiles();
            }
            break;
        }
      }

      modalFileUpload.value.show();
    };

    const editFileQuestion = async (obj: any) => {
      const result = await Swal.fire({
        html: `Si tienes cambios sin guardar, se perderán al continuar.<b></b> ¿Deseas continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí`,
        cancelButtonText: "Cancelar",
      });
      if (result.isConfirmed) {
        const payload = {
          nav: "1", //siguiente nivel del árbol
          playId: idPlay.value,
        };
        const encoded = btoa(JSON.stringify(payload));
        var dataQuizContentId = 0;
        if (playTypeId.value == PLAY_TYPES.COMBINE) {
          dataQuizContentId = playType.value.id;
        } else if (playTypeId.value == PLAY_TYPES.QUIZ) {
          dataQuizContentId = question.value.id;
        }

        if (dataQuizContentId == 0) {
          dataQuizContentId = Number(route.params.id);
        }

        router.push({
          name: "PlaysOptionEdit",
          params: {
            id: dataQuizContentId,
            "play-type": playTypeId.value,
            opid: obj.id,
          },
          query: {
            data: encoded,
          },
        });
      }
    };

    const removeQuestionOption = async (index: number) => {
      questionOptions.value.splice(index, 1);
    };

    const createPlayName = async () => {
      try {
        errors.value = {};
        await playName_Schema.validate({ playName: playName.value });
        isLoading.value = true;
        const response: any = await api.post(`/play/name`, playName.value);

        if (response != 0) {
          idPlay.value = response.data;
          toast.success(`La Jugada fue creada con éxito.`, {
            timeout: 2000,
          });
        } else {
          toast.error(`La Jugada no pudo ser creada.`, {
            timeout: 2000,
          });
        }
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          errors.value["playName"] = err.message;
        }
        isLoading.value = false;
      }
    };
    const handleUpdateFilesModal = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        if (questionOptionEdit.value) {
          if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            if (
              fileItems[0].file &&
              fileItems[0].file.type.startsWith("audio/")
            ) {
              questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
                fileItems[0].file
              );
            }
          }
        }
      }
    };

    const handleFilesModal = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        if (questionOptionEdit.value) {
          if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            if (
              fileItems[0].file &&
              fileItems[0].file.type.startsWith("audio/")
            ) {
              //audioUrlAction.value = URL.createObjectURL(fileItems[0].file);
              questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
                fileItems[0].file
              );
            }
          } else if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.IMAGE
          ) {
            questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
              fileItems[0].file
            );
          }
          questionOptionEdit.value.multimedia = fileItems.length
            ? fileItems[0].file
            : null;
        }
      }
    };
    const handleRemoveFileModal = () => {
      if (questionOptionEdit.value) {
        questionOptionEdit.value.multimedia = null;
        questionOptionEdit.value.urlMultimedia = null;
        //questionOptionEdit.value.multimediaTypeId =  null;
        if (filePondRefAction.value) {
          filePondRefAction.value?.removeFiles();
        }
      }
      clearAudioModal();
    };

    const resetValues = async () => {
      Object.assign(question.value, initialQuestion);
      Object.assign(playType.value, initialPlayType);
      questionOptions.value = [];
      questionOptionText.value = null;
      videoBlobUrl.value = null;
      videoBlobUrlQuestion.value = null;
      audioUrl.value = null;
      audioUrlQuestion.value = null;
      pdfUrl.value = null;
      pdfUrlQuestion.value = null;
    };

    const setMultimediaTypeQuestionOptionContent = (
      idMultimediaType: number | null
    ) => {
      if (idMultimediaType) {
        if (questionOptionEdit.value) {
          questionOptionEdit.value.urlMultimedia = null;
          questionOptionEdit.value.multimedia = null;
          if (filePondRefAction.value) {
            filePondRefAction.value?.removeFiles();
          }
        }

        switch (idMultimediaType) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormatsModal.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormatsModal.value = [...supportedFormatsAudio];
            break;
        }

        clearAudioModal();
      }
    };

    const clearAudioModal = () => {
      if (questionOptionEdit.value) {
        if (questionOptionEdit.value.urlMultimediaBlob) {
          URL.revokeObjectURL(questionOptionEdit.value.urlMultimediaBlob);
          questionOptionEdit.value.urlMultimediaBlob = null;
        }
      }
    };

    const removeMultimediaFileModal = async () => {
      if (filePondRefAction.value) {
        filePondRefAction.value?.removeFiles();
      }
      if (questionOptionEdit.value) {
        questionOptionEdit.value.urlMultimedia = null;
        questionOptionEdit.value.multimedia = null;
        //questionOptionEdit.value.multimediaTypeId = null
        clearAudioModal();
      }
    };

    const closeModalFile = () => {
      const files = filePondRefAction.value?.getFiles() || [];
      console.log("files: " + files);
      if (files.length > 0) {
        handleFilesModal(files);
      } else {
        if (
          questionOptionEdit.value &&
          questionOptionEdit.value.urlMultimediaBlob == null
        ) {
          questionOptionEdit.value.multimediaTypeId = null;
        }
      }

      if (filePondRefAction.value) {
        filePondRefAction.value?.removeFiles();
      }

      modalFileUpload.value.hide();
    };

    const closeModalFileQuestion = () => {
      modalFileUploadQuestion.value.hide();
    };

    return {
      playTypeId,
      pIdPlayType,
      itemsQuestionTypes,
      itemsAnswerTypes,
      itemsQuestion,
      itemsConfigNext,
      paramIsQuestion,
      PLAY_TYPES,
      idPlay,
      handleUpdateFiles,
      handleQuizContentChange,
      createPlayType,
      validateForm_Content,
      clearError,
      removeMultimediaFile,
      handleRemoveFile,
      setMultimediaTypeContent,
      LABELS,
      MULTIMEDIA_TYPES,
      QUESTION_TYPE,
      ANSWER_TYPES,
      playType,
      itemsTournament,
      errors,
      isLoading,
      isLoadingCreate,
      es,
      supportedFormats,
      supportedFormatsModal,
      multimediaOptions,
      filePondRef,
      videoBlobUrl,
      videoBlobUrlQuestion,
      audioUrl,
      audioUrlQuestion,
      pdfUrl,
      pdfUrlQuestion,
      validateForm_Question,
      filePondRefQuestion,
      question,
      handleQuestionInput,
      removeQuestionOption,
      addQuestionOption,
      editQuestionOption,
      editOption,
      cancelEdit,
      saveOption,
      questionOptionText,
      questionOptions,
      dragStart,
      dragEnd,
      dragDrop,
      drop,
      playName,
      createPlayName,
      route,
      resetValues,
      editFile,
      editFileQuestion,
      questionOptionEdit,
      questionOptionFreeEdit,
      handleUpdateFilesModal,
      handleRemoveFileModal,
      filePondRefAction,
      setMultimediaTypeQuestionOptionContent,
      removeMultimediaFileModal,
      closeModalFile,
      closeModalFileQuestion,
      PrevPage,
      OverlayLoader,
      playConfigPage,
    };
  },
});
</script>
